import { createLightTheme, createDarkTheme } from '@fluentui/react-components';

// Brand ramp derived from the RewordGenie emerald brand color (#059669).
// Fluent's createLightTheme/createDarkTheme expect 16 shades (10..160).
// Generated to keep emerald-600 (#059669) near the primary brand slot (80/100)
// so primary actions read as the brand color in both appearances.
const rewordgenieBrandRamp = {
  10: '#020A07',
  20: '#0A1A13',
  30: '#0E2A1E',
  40: '#103626',
  50: '#13422F',
  60: '#155037',
  70: '#175E40',
  80: '#047857', // emerald-700
  90: '#05875F',
  100: '#059669', // emerald-600 — primary brand color
  110: '#10A674',
  120: '#22B381',
  130: '#34D399', // emerald-400
  140: '#6EE7B7',
  150: '#A7F3D0',
  160: '#D1FAE5',
};

export const rewordgenieLightTheme = createLightTheme(rewordgenieBrandRamp);
export const rewordgenieDarkTheme = createDarkTheme(rewordgenieBrandRamp);
